<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1">For my family. Almost a dynasty . . . <br/>With lots of love.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590207949_oeb_ded_r1.vue?014c4c6c